<template>
  <NuxtLayout :name="layoutName">
    <ErrorNotFound v-if="type === 'not-found'" :error="error" />
    <ErrorUnexpected v-else :error="error" />
  </NuxtLayout>
</template>

<script setup lang="ts">
import type { NuxtError } from "#app";

const props = defineProps<{ error: NuxtError }>();
const type = computed<"not-found" | "unexpected">(() => {
  if (props.error.statusCode === 404) return "not-found";
  return "unexpected";
});
const { loggedIn } = useAppSession();
// show the default layout if logged in, otherwise no layout
const layoutName = computed(() => {
  return loggedIn.value ? "default" : false;
});
</script>
